import React from 'react';
import { Zap } from 'lucide-react';
import { FLAVOURS } from '../data/mock';

// ORIGINAL premium S-MAN product box (placeholder until official product photo is set via f.box).
// size: 'sm' | 'md' | 'lg'
export default function ProductBox({ flavourId = 'strawberry', size = 'md', glow = true, className = '', showFruit = true, scene = false }) {
  const f = FLAVOURS[flavourId] || FLAVOURS.strawberry;
  const dims = {
    sm: 'w-28 h-40',
    md: 'w-52 h-72',
    lg: 'w-72 h-96',
  }[size];
  const nameSize = { sm: 'text-[9px]', md: 'text-xs', lg: 'text-sm' }[size];

  // If an official product photo is provided in data (f.box), render it.
  const photo = scene && f.scene ? f.scene : f.box;
  if (photo) {
    const boxW = { sm: 'w-40', md: 'w-64', lg: 'w-full max-w-[540px] mx-auto' }[size];
    return (
      <div className={`relative ${boxW} ${className}`} style={{ ['--flavour-primary']: f.primary, ['--flavour-rgb']: f.rgb }}>
        {glow && (
          <div className="absolute inset-0 -z-10 blur-3xl opacity-70" style={{ background: `radial-gradient(circle at 50% 50%, rgba(${f.rgb},0.55), transparent 65%)` }} />
        )}
        <img src={photo} alt={`S-MAN ${f.name}`} loading="lazy" className="w-full h-auto object-contain drop-shadow-2xl" />
      </div>
    );
  }

  return (
    <div className={`relative ${className}`} style={{ ['--flavour-primary']: f.primary, ['--flavour-secondary']: f.secondary, ['--flavour-rgb']: f.rgb }}>
      {glow && (
        <div
          className="absolute inset-0 -z-10 blur-3xl opacity-60"
          style={{ background: `radial-gradient(circle at 50% 45%, rgba(${f.rgb},0.55), transparent 65%)` }}
        />
      )}
      <div
        className={`relative ${dims} rounded-xl overflow-hidden border border-white/10 shadow-2xl`}
        style={{ background: 'linear-gradient(160deg, #121212 0%, #070707 60%, #0d0d0d 100%)' }}
      >
        {/* top accent bar */}
        <div className="absolute top-0 left-0 right-0 h-1.5" style={{ background: f.primary }} />
        {/* diagonal streak */}
        <div
          className="absolute -right-8 top-8 h-[140%] w-16 rotate-12 opacity-30"
          style={{ background: `linear-gradient(180deg, ${f.primary}, transparent)` }}
        />
        <div className="h-full flex flex-col items-center justify-between p-4 text-center">
          <div className="flex items-center gap-1 pt-1">
            <Zap className="w-5 h-5" style={{ color: f.primary }} fill={f.primary} />
          </div>

          <div className="flex flex-col items-center gap-2">
            {showFruit && (
              <div className="relative">
                <div className="absolute inset-0 rounded-full blur-xl opacity-70" style={{ background: f.primary }} />
                <img
                  src={f.fruit}
                  alt={f.name}
                  loading="lazy"
                  className="relative w-16 h-16 md:w-20 md:h-20 rounded-full object-cover border-2"
                  style={{ borderColor: f.primary }}
                />
              </div>
            )}
            <div className="font-display text-white leading-none" style={{ fontSize: size === 'lg' ? 26 : size === 'md' ? 20 : 13 }}>
              S-<span style={{ color: f.primary }}>MAN</span>
            </div>
            <div className="text-[8px] tracking-[0.25em] text-white/60 font-cond">FEEL THE POWER</div>
          </div>

          <div className="w-full">
            <div className={`font-cond font-bold tracking-wide ${nameSize}`} style={{ color: f.primary }}>
              {f.name} FLAVOUR
            </div>
            <div className="text-[7px] tracking-[0.2em] text-white/40 font-cond mt-0.5">DIETARY SUPPLEMENT</div>
          </div>
        </div>
      </div>
    </div>
  );
}
